// 组件选中状态混入，用于管理组件的选中状态

import ComponentManager from '../utils/ComponentManager';
export default {
  data() {
    return {
      // 组件实例列表，由使用该混入的组件提供
      componentInstances: [],
      // 撤销操作相关
      history: [],
      historyIndex: -1
    };
  },
  computed: {
    // 获取当前选中的组件
    selectedComponent() {
      return this.findSelectedComponent(this.componentInstances);
    }
  },
  methods: {
    // 递归查找选中的组件
    findSelectedComponent(components) {
      for (const component of components) {
        if (component.selected) {
          return component;
        }
        if (component.children && component.children.length > 0) {
          const found = this.findSelectedComponent(component.children);
          if (found) {
            return found;
          }
        }
      }
      return null;
    },
    
    // 根据ID查找组件（包括子组件）
    findComponentById(componentId, components = null) {
      const componentsToSearch = components || this.componentInstances;
      
      for (const component of componentsToSearch) {
        if (component.id === componentId) {
          return component;
        }
        
        if (component.children && component.children.length > 0) {
          const foundChild = this.findComponentById(componentId, component.children);
          if (foundChild) {
            return foundChild;
          }
        }
      }
      
      return null;
    },
    // 选择组件
    selectComponent(componentId) {
      // 取消所有组件的选中状态
      this.clearSelection();
      
      // 递归查找并选中指定组件
      const findAndSelect = (components) => {
        for (const component of components) {
          if (component.id === componentId) {
            component.selected = true;
            return true;
          }
          if (component.children && component.children.length > 0) {
            if (findAndSelect(component.children)) {
              return true;
            }
          }
        }
        return false;
      };
      
      findAndSelect(this.componentInstances);
    },
    
    // 清除选择
    clearSelection() {
      // 递归取消所有组件的选择状态
      this.clearSelectionRecursive(this.componentInstances);
    },
    
    // 递归清除选择状态
    clearSelectionRecursive(components) {
      components.forEach(component => {
        component.selected = false;
        // 递归取消子组件的选择状态
        if (component.children) {
          this.clearSelectionRecursive(component.children);
        }
      });
    },
    // 添加组件到画布
    addComponentToCanvas(componentName) {
      const componentInstance = ComponentManager.createComponentInstance(componentName);
      if (componentInstance) {
        // 保存历史记录
        this.saveHistory('add');
        
        // 传递画布宽度给组件实例，用于边框计算
        componentInstance.canvasWidth = this.canvasWidth - this.pageProperties.paddingLeft - this.pageProperties.paddingRight;
        // 根据文档流设置组件位置
        this.setComponentPosition(componentInstance);
        
        let parent = null;
        
        // 检查是否有选中的容器组件，如果有则将新组件添加到容器中
        if (this.selectedComponent) {
          if (this.selectedComponent.componentName === 'container') {
            parent = this.selectedComponent;
          }else if (this.selectedComponent.parentId) {
            const parentParent = this.findComponentById(this.componentInstances, this.selectedComponent.parentId);
            if (parentParent != null && parentParent.componentName === 'container') {
              parent = this.selectedComponent.parent;
            }
          }
        }
        
        // 检查是否有选中的容器组件，如果有则将新组件添加到容器中
        if (parent) {
          // 确保容器有children属性
          if (!parent.children) {
            parent.children = [];
          }
          // 将组件添加到容器的children数组中
          componentInstance.canvasWidth = document.getElementById(parent.id).clientWidth;
          componentInstance.parentId = this.selectedComponent.id;
          parent.children.push(componentInstance);
        } else {
          // 将组件添加到顶层组件实例数组中
          this.componentInstances.push(componentInstance);
        }
        
        // 选中新添加的组件
        this.selectComponent(componentInstance.id);
      }
    },
    // 设置组件文档流位置
    setComponentPosition(componentInstance) {
      const props = componentInstance.props;
      let componentHeight;
      
      // 根据组件类型计算高度和宽度
      if (componentInstance.componentName === 'hanzizitie') {
        const originalRows = (props.characters || '').length + (props.kongxing || 0);
        const cellSize = props.cellSize || 56.7; // 1.5cm 转换为像素
        const rowGap = props.rowGap !== undefined ? props.rowGap : 10;
        const containerPadding = 0; // 上下各10px的内边距
        
        // 计算单个行高（包含行间距）
        const rowHeightWithGap = cellSize + rowGap;
        
        // 检查组件总高度是否超过画布高度
        const totalHeightAfterAdding = this.documentFlow.currentY + 
                                     (originalRows * cellSize) + 
                                     ((originalRows - 1) * rowGap) + 
                                     containerPadding + 
                                     (props.marginTop || 0) + 
                                     (props.marginBottom || 0);
        
        let actualRows = originalRows;
        
        if (totalHeightAfterAdding > this.canvasHeight) {
          // 计算可容纳的最大行数
          const availableHeight = this.canvasHeight - 
                                 this.documentFlow.currentY - 
                                 containerPadding - 
                                 (props.marginTop || 0) - 
                                 (props.marginBottom || 0);
          
          if (availableHeight <= 0) {
            // 如果没有可用高度，不添加组件
            return;
          }
          
          // 计算可容纳的最大行数
          // 总高度 = rows * cellSize + (rows - 1) * rowGap = rows * (cellSize + rowGap) - rowGap
          // 解这个方程：availableHeight = rows * (cellSize + rowGap) - rowGap
          actualRows = Math.floor((availableHeight + rowGap) / (cellSize + rowGap));
          
          // 确保至少有一行
          actualRows = Math.max(1, actualRows);
        }
        
        // 计算实际组件高度
        const totalRowHeight = actualRows * cellSize;
        const totalMarginBottom = actualRows > 0 ? (actualRows - 1) * rowGap : 0;
        componentHeight = totalRowHeight + totalMarginBottom + containerPadding;
        // 保存组件高度到实例中，供初始渲染使用
        componentInstance.height = componentHeight;
      } else if (componentInstance.componentName === 'title') {
        componentHeight = (props.fontSize || 32) * (props.lineHeight || 1.2);
        // 保存组件高度到实例中，供初始渲染使用
        componentInstance.height = componentHeight;
      } else if (componentInstance.componentName === 'info') {
        componentHeight = (props.fontSize || 16) * 1.5;
        // 保存组件高度到实例中，供初始渲染使用
        componentInstance.height = componentHeight;
      } else {
        componentHeight = props.height || props.size || 100;
        // 保存组件高度到实例中，供初始渲染使用
        componentInstance.height = componentHeight;
      }
      
      // 对于文档流布局，不再需要手动设置x、y坐标和更新文档流位置
      // 组件将通过CSS的margin和padding自动排列
      // 移除了复杂的高度检查和位置计算，简化了逻辑
      // 页面内边距通过canvas-components-container的padding样式处理
      
      // 不再需要文档流位置计算和更新
      // 不再需要可用高度检查
      // 不再需要手动设置组件x、y坐标
      
      // 组件的宽度由CSS自动处理，使用100%宽度减去页面内边距
      // 组件的高度由组件自身属性决定
      // 组件的位置由文档流自动决定，考虑margin和padding
    },
    
    // 获取组件样式
    getComponentStyle(component) {
      const props = component.props;
      let width, height;
      
      // 宽度计算：
      // 所有组件：宽度占满整行，使用完整画布宽度
      width = this.canvasWidth;
      
      // 根据组件类型计算高度
      if (component.componentName === 'hanzizitie') {
        const originalRows = (props.characters || '').length + (props.kongxing || 0);
        const cellSize = props.cellSize || 56.7; // 1.5cm 转换为像素
        const rowGap = props.rowGap !== undefined ? props.rowGap : 10; // 默认行间距为10px
        const containerPadding = 0; // 上下各10px的内边距
        
        // 计算单个行高（包含行间距）
        const rowHeightWithGap = cellSize + rowGap;
        
        // 检查组件总高度是否超过画布高度
        const totalHeightAfterAdding = component.y + 
                                     (originalRows * cellSize) + 
                                     ((originalRows - 1) * rowGap) + 
                                     containerPadding + 
                                     (props.marginTop || 0) + 
                                     (props.marginBottom || 0);
        
        let actualRows = originalRows;
        
        if (totalHeightAfterAdding > this.canvasHeight) {
          // 计算可容纳的最大行数
          const availableHeight = this.canvasHeight - 
                                 component.y - 
                                 containerPadding - 
                                 (props.marginTop || 0) - 
                                 (props.marginBottom || 0);
          console.log('availableHeight:', availableHeight);
          if (availableHeight <= 0) {
            // 如果没有可用高度，使用1行
            actualRows = 1;
          } else {
            // 计算可容纳的最大行数
            // 总高度 = rows * cellSize + (rows - 1) * rowGap = rows * (cellSize + rowGap) - rowGap
            // 解这个方程：availableHeight = rows * (cellSize + rowGap) - rowGap
            actualRows = Math.floor((availableHeight + rowGap) / (cellSize + rowGap));
            
            // 确保至少有一行
            actualRows = Math.max(1, actualRows);
          }
        }
        
        // 计算实际组件高度
        const totalRowHeight = actualRows * cellSize;
        const totalMarginBottom = actualRows > 0 ? (actualRows - 1) * rowGap : 0;
        height = totalRowHeight + totalMarginBottom + containerPadding;
      } else if (component.componentName === 'title') {
        // 标题组件：高度根据字体大小和行高计算
        height = (props.fontSize || 32) * (props.lineHeight || 1.2);
      } else if (component.componentName === 'info') {
        // 信息组件：高度根据字体大小计算
        height = (props.fontSize || 16) * 1.5;
      } else if (component.componentName === 'container') {
        // 容器组件：不设置固定高度，让它根据内容自动调整
        // 只保存最小高度
        height = props.height || 100;
      } else if (component.componentName === 'pinyin') {
        const pinyinList = props.characters ? props.characters.split('\n').map(p => p.trim()).filter(p => p) : [];
        const kongxing = props.kongxing || 0;
        const originalRows = pinyinList.length + kongxing;
        const lineHeight = (props.lineHeight || 10) * 3.7795; // 转换为像素
        const rowGap = (props.rowGap || 5) * 3.7795; // 转换为像素

        // 检查组件总高度是否超过画布高度
        const totalHeightAfterAdding = this.documentFlow.currentY + 
                                     (originalRows * lineHeight) + 
                                     ((originalRows - 1) * rowGap) + 
                                     (props.marginTop || 0) + 
                                     (props.marginBottom || 0);
        
        let actualRows = originalRows;
        
        if (totalHeightAfterAdding > this.canvasHeight) {
          // 计算可容纳的最大行数
          const availableHeight = this.canvasHeight - 
                                 this.documentFlow.currentY - 
                                 (props.marginTop || 0) - 
                                 (props.marginBottom || 0);
          
          if (availableHeight <= 0) {
            // 如果没有可用高度，不添加组件
            return;
          }
          
          // 计算可容纳的最大行数
          // 总高度 = rows * cellSize + (rows - 1) * rowGap = rows * (cellSize + rowGap) - rowGap
          // 解这个方程：availableHeight = rows * (cellSize + rowGap) - rowGap
          actualRows = Math.floor((availableHeight + rowGap) / (lineHeight + rowGap));
          
          // 确保至少有一行
          actualRows = Math.max(1, actualRows);
        }
        
        // 计算实际组件高度
        const totalRowHeight = actualRows * lineHeight;
        const totalMarginBottom = actualRows > 0 ? (actualRows - 1) * rowGap : 0;
        height = totalRowHeight + totalMarginBottom;

        // 保存组件高度到实例中，供初始渲染使用
      } else {
        // 其他组件：使用height或size属性，默认高度
        height = props.height || props.size || 100;
      }
      
      // 保存组件高度到实例中，供renderHtml使用
      component.height = height;
    
      // 返回组件样式
      return {
        width: `${width}px`,
        height: component.componentName === 'container' ? 'auto' : `${height}px`,
        minHeight: component.componentName === 'container' ? `${height}px` : 'auto',
        backgroundColor: props.backgroundColor || 'transparent'
      };
    },
    // 删除选中的组件
    deleteSelectedComponent() {
      if (!this.selectedComponent) return;
      
      // 找到并删除组件
      this.deleteComponent(this.selectedComponent.id);
      // 重新排列组件位置
      this.reflowComponents();
      // 清空选择
      this.clearSelection();

    },
    
    // 删除组件
    deleteComponent(componentId) {
      // 保存历史记录
      this.saveHistory('delete');
      
      let delFlag = false;
      // 查找组件索引
      const index = this.componentInstances.findIndex(c => c.id === componentId);
      if (index !== -1) {
        // 删除组件
        this.componentInstances.splice(index, 1);

        delFlag = true;
      } else {
        // 从父容器中删除子组件
        this.componentInstances.forEach(component => {
          if (component.children) {
            const childIndex = component.children.findIndex(c => c.id === componentId);
            if (childIndex !== -1) {
              component.children.splice(childIndex, 1);
              delFlag = true;
            }
          }
        });
      }

      if (delFlag) {
        // 重新排列组件位置
        this.reflowComponents();
      }
    },
    // 保存操作历史
    saveHistory(action) {
      // 截断历史记录到当前索引
      this.history = this.history.slice(0, this.historyIndex + 1);
      // 保存当前组件状态
      this.history.push({
        action,
        componentInstances: JSON.parse(JSON.stringify(this.componentInstances)),
        timestamp: Date.now()
      });
      // 更新历史索引
      this.historyIndex = this.history.length - 1;
    },
    // 查找组件的辅助函数
    findComponentById(components, id) {
      for (const component of components) {
        if (component.id === id) {
          return component;
        }
        if (component.children && component.children.length > 0) {
          const found = findComponentById(component.children, id);
          if (found) {
            return found;
          }
        }
      }
      return null;
    }
  }
};